export const DeviceOrientation = {
  Unspecified: 0,
  Portrait: 1,
  Landscape: 2,
} as const;

export type DeviceOrientation = (typeof DeviceOrientation)[keyof typeof DeviceOrientation];